module.exports = __webpack_public_path__ + "img/menu_tk_new.8e4af973.png";